import React from 'react';
import { Input, Select } from 'formsy-react-components';
import { stateOptions } from '../../utils';

export const BasicJobInfo = React.createClass({
  render() {
    const { job } = this.props;

    return (
      <div>
        <div>
          <Input
            label="Site Name"
            type="text"
            name="site_name"
            value={job.get('site_name') || ''}
            placeholder="Site Name"
            labelClassName="small-12"
            elementWrapperClassName="small-12"
            required
          />
          <Input
            label="Street 1"
            type="text"
            name="street_1"
            value={job.get('street_1') || ''}
            placeholder="Street 1"
            labelClassName="small-12"
            elementWrapperClassName="small-12"
            required
          />
          <Input
            label="Apt/Suite #"
            type="text"
            name="street_2"
            value={job.get('street_2') || ''}
            placeholder="Street 2"
            labelClassName="small-12"
            elementWrapperClassName="small-12"
          />
          <Input
            label="City"
            type="text"
            name="city"
            value={job.get('city') || ''}
            placeholder="City"
            labelClassName="small-12"
            elementWrapperClassName="small-12"
            required
          />
          <Select
            label="State"
            name="state"
            options={stateOptions}
            value={job.get('state') || ''}
            labelClassName="small-12"
            elementWrapperClassName="small-12"
            required
          />
          <Input
            label="Zipcode"
            type="text"
            name="zipcode"
            value={job.get('zipcode') || ''}
            placeholder="Zipcode"
            labelClassName="small-12"
            elementWrapperClassName="small-12"
            required
          />
        </div>
      </div>
    );
  }
});



/** WEBPACK FOOTER **
 ** ./src/components/jobs/basic-job-info.jsx
 **/